import { FC } from "react";
import { Column, Row } from "../../../../../components/containers";
import { ChatState } from "../../../types";
import { useThemeStore } from "../../../../../stores";
import { Wrap } from "../../../../../components/containers/types";
import { IconAnimation } from "../../../../../components/animation";
import { CloseIcon, DocumentIcon } from "../../../../../assets/icons";
import { UpdateFn } from "../../../../../types";
import { Text } from "../../../../../components/typography";

const ChatBodyFooterFiles: FC<
  { files: FileList | null; setFiles: UpdateFn<FileList | null> } & ChatState
> = ({ files, isSidePanel, setFiles }) => {
  const theme = useThemeStore((s) => s.theme);

  return files && files.length ? (
    <Row
      style={{
        position: "absolute",
        bottom: "100%",
        right: 0,
        width: "calc(100% - 16px)",
        padding: 8,
        boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
      }}
      background={isSidePanel ? theme.overlay : theme.background}
      flexWrap={Wrap.Wrap}
      gap={20}
    >
      <IconAnimation
        Icon={CloseIcon}
        onHoverColor={theme.alert}
        style={{
          cursor: "pointer",
          position: "absolute",
          top: 10,
          left: 10,
        }}
        width={20}
        height={20}
        onClick={() => setFiles(null)}
      />

      {Array.from(files).map((file) =>
        file.type.startsWith("image/") ? (
          <img
            key={file.name}
            src={URL.createObjectURL(file)}
            alt={file.name}
            width={100}
            style={{ borderRadius: 15 }}
          />
        ) : (
          <Column gap={5} key={file.name}>
            <DocumentIcon
              width={20}
              height={20}
              color={isSidePanel ? theme.textOnOverlay : theme.textOnBg}
            />

            <Text color={isSidePanel ? theme.textOnOverlay : theme.textOnBg}>
              {file.name}
            </Text>
          </Column>
        )
      )}
    </Row>
  ) : (
    <></>
  );
};

export default ChatBodyFooterFiles;
